/* eslint-disable max-lines-per-function */
import ActiveTransportation from "./pages/ActiveTransportation";
import Covid from "./pages/Covid";
import Default from "./pages/Default";
import DetailPage from "./pages/DetailPage";
import FaitsSaillants from "./pages/FaitsSaillants";
import Governance from "./pages/Governance";
import { HomePage } from "./pages/HomePage";
import NewHomePage from "./pages/HomePage";
import Newsletter from "./pages/Newsletter";
import NousJoindre from "./pages/NousJoindre";
import RefonteTarifaire from "./pages/RefonteTarifaire";
import RefonteTarifaireSingleZone from "./pages/RefonteTarifaireSingleZone";
import SingleGrandsProjets from "./pages/SingleGrandsProjets";
import Stationnements from "./pages/Stationnements";
import TitreADecouvrir from "./pages/TitreADecouvrir";
import Zones from "./pages/Zones";
import Campagne from "./pages/Campagne";
import Flexible from "./pages/Flexible";

class Main {
  /**
   * Constructor of the class.
   *
   * @return void
   */
  constructor() {
    console.log("Main :: init");

    document.addEventListener("DOMContentLoaded", this.init);
  }

  init() {
    const menuItems = document.querySelectorAll('ul.menu li.menu-item');

    menuItems.forEach((menuItem) => {
      // Listen for mouse leave to remove the disable-hover class
      menuItem.addEventListener('mouseleave', () => {
        document.documentElement.classList.remove('disable-hover');
      });
      // remove the disable-hover if mouse wasn't over the menu item
      menuItem.addEventListener('mouseenter', () => {
        document.documentElement.classList.remove('disable-hover');
      });
      // remove the disable-hover if we tab into the menu item
      menuItem.addEventListener('keydown', (e) => {
        if (e.keyCode === 9) {
          document.documentElement.classList.remove('disable-hover');
        }
      });
    });


    const main = document.querySelector("main");
    const lang = document.documentElement.lang;
    this.page = null;

    switch (true) {
      case main.id == "home":
        this.page = new HomePage("home", main, lang);
        break;
      case main.id == "new-home":
        this.page = new NewHomePage("home", main, lang);
        break;
      case main.id == "faits-saillants":
        this.page = new FaitsSaillants("home", main, lang);
        break;
      case main.id == "covid":
        this.page = new Covid("home", main, lang);
        break;
      case main.id == "nous-joindre":
        this.page = new NousJoindre("home", main, lang);
        break;
      case main.id == "single-projet":
        this.page = new SingleGrandsProjets("home", main, lang);
        break;
      case main.dataset.js == "governance":
        this.page = new Governance(main, lang);
        break;
      case main.id == "refonte-tarifaire":
        this.page = new RefonteTarifaire("home", main, lang);
        break;
      case main.id == "transport-adapte":
        this.page = new RefonteTarifaire("home", main, lang);
        break;
      case main.id == "active-transportation":
        this.page = new ActiveTransportation("home", main, lang);
        break;
      case main.id == "refonte-tarifaire-single-zone":
        this.page = new RefonteTarifaireSingleZone("home", main, lang);
        break;
      case main.id == "transport-adapte-single-zone":
        this.page = new RefonteTarifaireSingleZone("home", main, lang);
        break;
      case main.id == "stationnement":
        this.page = new Stationnements("home", main, lang);
        break;
      case main.id == "titres-a-decouvrir-tr-ta":
        this.page = new TitreADecouvrir("home", main, lang);
        break;
      case main.id == "titres-a-decouvrir-ta":
        this.page = new TitreADecouvrir("home", main, lang);
        break;
      case main.id == "newsletter":
        this.page = new Newsletter("home", main, lang);
        break;
      case main.id == "page-zones":
        this.page = new Zones("home", main, lang);
        break;
      case main.id == "detail-mode":
        this.page = new DetailPage("home", main, lang);
        break;
      case main.id == "campagne":
        this.page = new Campagne("home", main, lang);
        break;
      case main.id == "flexible":
        this.page = new Flexible("flexible", main, lang);
        break;
      default:
        this.page = new Default("default", main, lang);
        break;
    }
  }
}
new Main();
